// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__1QPct"};